module.exports = __webpack_public_path__ + "img/awards_image_01.3941060c.jpg";